import { InfiniteData } from 'react-query'
import {
  useApproveDocument,
  useCreateDocument,
  useCreateDocumentFolder,
  useDownloadDocument,
  useDuplicateDocument,
  useFetchDocument,
  useFetchDocumentFolderList,
  useFetchDocumentList,
  useFetchTrashedDocumentList,
  usePublishDocument,
  useRemoveDocument,
  useRemoveDocumentFolder,
  useRequestDocumentSignature,
  useSendDocumentSignatureReminder,
  useShareDocument,
  useSubmitDocument,
  useUpdateDocument,
  useUpdateDocumentFolder,
  useUploadPDFDocument,
} from './documents'
import { useUploadToEmployee, useFetchEmployeeCategories } from './employees'
import { useSubscribe, useFetchSubscriptionList } from './subscriptions'
import {
  useCreateTemplate,
  useCreateTemplateFolder,
  useDuplicateTemplate,
  useFetchTemplate,
  useFetchTemplateList,
  useFetchTemplateFolderList,
  useFetchTemplatePreviewImageSrcURL,
  useFetchTrashedTemplateList,
  usePublishTemplate,
  useRemoveTemplate,
  useRemoveTemplateFolder,
  useShareTemplate,
  useToggleCompanyShareTemplate,
  useUnshareTemplate,
  useUpdateTemplate,
  useUpdateTemplateFolder,
  useUploadTemplatePreviewImage,
} from './templates'
import { useFetchExternalServices, useFetchExternalServiceEntries, useFetchExternalServiceEntry, useFetchUser, useLogoutUser } from './users'

const QUERY_KEYS = {
  USER: 'QUERY_USER',
  TEAM: 'QUERY_TEAM',
  DOCUMENTS: 'QUERY_DOCUMENTS',
  TRASHED_DOCUMENTS: 'QUERY_TRASHED_DOCUMENTS',
  DOCUMENT_FOLDERS: 'QUERY_DOCUMENT_FOLDERS',
  DOCUMENT: 'QUERY_DOCUMENT',
  DOCUMENT_DOWNLOAD: 'QUERY_DOCUMENT_DOWNLOAD',
  DOCUMENT_SIGNATURE_REQUEST: 'QUERY_DOCUMENT_SIGNATURE_REQUEST',
  SIGNED_DOCUMENT_DOWNLOAD: 'QUERY_SIGNED_DOCUMENT_DOWNLOAD',
  TEMPLATES: 'QUERY_TEMPLATES',
  TRASHED_TEMPLATES: 'QUERY_TRASHED_TEMPLATES',
  TEMPLATE_FOLDERS: 'QUERY_TEMPLATE_FOLDERS',
  TEMPLATE: 'QUERY_TEMPLATE',
  TEMPLATE_PREVIEW_IMAGE: 'QUERY_TEMPLATE_PREVIEW_IMAGE',
  EXTERNAL_SERVICES: 'QUERY_EXTERNAL_SERVICES', // ------------------ eg. Bamboo HR
  EXTERNAL_SERVICE_ENTRIES: 'QUERY_EXTERNAL_SERVICE_ENTRIES', // ---- eg. employee list
  EXTERNAL_SERVICE_ENTRY: 'QUERY_EXTERNAL_SERVICE_ENTRY', // -------- eg. Pera Peric (an employee)
  SUBSCRIPTIONS: 'QUERY_SUBSCRIPTIONS',
  SUBSCRIPTION: 'QUERY_SUBSCRIPTION',

  // INTEGRATIONS
  UPLOAD_TO_BAMBOO: 'MUTATE_UPLOAD_TO_BAMBOO',
  BAMBOO_EMPLOYEE_CATEGORIES: 'QUERY_BAMBOO_EMPLOYEE_CATEGORIES',

  // DEPRECATED
  UPLOAD_TO_EXTERNAL: 'MUTATE_UPLOAD_TO_EXTERNAL',
  EXTERNAL_SERVICE_EMPLOYEE_CATEGORIES: 'QUERY_EXTERNAL_SERVICE_EMPLOYEE_CATEGORIES', // eg. Pera Peric's categories
}
const STALE_TIME = 5 * 60 * 1000
export { QUERY_KEYS, STALE_TIME }

export type {
  ApproveDocumentVariables,
  ApproveDocumentFunctionType,
  CreateDocumentVariables,
  CreateDocumentFunctionType,
  CreateDocumentFolderVariables,
  CreateDocumentFolderFunctionType,
  CreateDocumentFolderMutationOptions,
  DownloadRegularDocumentVariables,
  DownloadRegularDocumentFunctionType,
  DownloadPDFDocumentVariables,
  DownloadPDFDocumentFunctionType,
  DownloadSignedDocumentVariables,
  DownloadSignedDocumentFunctionType,
  DuplicateDocumentVariables,
  DuplicateDocumentFunctionType,
  PublishDocumentVariables,
  PublishDocumentFunctionType,
  RemoveDocumentVariables,
  RemoveDocumentFunctionType,
  RemoveDocumentFolderVariables,
  RemoveDocumentFolderFunctionType,
  RequestRegularDocumentSignatureVariables,
  RequestRegularDocumentSignatureFunctionType,
  RequestPDFDocumentSignatureVariables,
  RequestPDFDocumentSignatureFunctionType,
  SendDocumentSignatureReminderVariables,
  SendDocumentSignatureReminderFunctionType,
  ShareDocumentVariables,
  ShareDocumentFunctionType,
  UnshareDocumentVariables,
  UnshareDocumentFunctionType,
  SubmitDocumentVariables,
  SubmitDocumentFunctionType,
  UpdateDocumentVariables,
  UpdateDocumentFunctionType,
  UpdateDocumentFolderVariables,
  UpdateDocumentFolderFunctionType,
  UploadPDFDocumentVariables,
  UploadPDFDocumentFunctionType,
} from './documents'
export type {
  CreateTemplateVariables,
  CreateTemplateFunctionType,
  CreateTemplateFolderVariables,
  CreateTemplateFolderFunctionType,
  CreateTemplateFolderMutationOptions,
  DuplicateTemplateVariables,
  DuplicateTemplateFunctionType,
  PublishTemplateVariables,
  PublishTemplateFunctionType,
  RemoveTemplateVariables,
  RemoveTemplateFunctionType,
  RemoveTemplateFolderVariables,
  RemoveTemplateFolderFunctionType,
  ShareTemplateVariables,
  ShareTemplateFunctionType,
  ToggleCompanyShareTemplateVariables,
  ToggleCompanyShareTemplateFunctionType,
  UnshareTemplateVariables,
  UnshareTemplateFunctionType,
  UpdateTemplateVariables,
  UpdateTemplateFunctionType,
  UpdateTemplateFolderVariables,
  UpdateTemplateFolderFunctionType,
  UploadImageVariables,
} from './templates'

export {
  useApproveDocument,
  useCreateDocument,
  useCreateDocumentFolder,
  useDownloadDocument,
  useDuplicateDocument,
  useFetchDocument,
  useFetchDocumentFolderList,
  useFetchDocumentList,
  useFetchTrashedDocumentList,
  usePublishDocument,
  useRemoveDocument,
  useRemoveDocumentFolder,
  useRequestDocumentSignature,
  useSendDocumentSignatureReminder,
  useShareDocument,
  useSubmitDocument,
  useUpdateDocument,
  useUpdateDocumentFolder,
  useUploadPDFDocument,
}
export { useUploadToEmployee, useFetchEmployeeCategories }
export { useSubscribe, useFetchSubscriptionList }
export {
  useCreateTemplate,
  useCreateTemplateFolder,
  useDuplicateTemplate,
  useFetchTemplate,
  useFetchTemplateList,
  useFetchTemplateFolderList,
  useFetchTemplatePreviewImageSrcURL,
  useFetchTrashedTemplateList,
  usePublishTemplate,
  useRemoveTemplate,
  useRemoveTemplateFolder,
  useShareTemplate,
  useToggleCompanyShareTemplate,
  useUnshareTemplate,
  useUpdateTemplate,
  useUpdateTemplateFolder,
  useUploadTemplatePreviewImage,
}
export { useFetchExternalServices, useFetchExternalServiceEntries, useFetchExternalServiceEntry, useFetchUser, useLogoutUser }

export * from './integrations'

const reduceEntriesIntoPages = <T extends { id: string }>(entries: T[], perPage: number): InfiniteData<T[]> =>
  entries.reduce(
    (accumulated, entry) => {
      const { pages, pageParams } = accumulated
      const lastPage = pages[pages.length - 1]
      if (!lastPage) {
        pages.push([entry])
        pageParams.push(null)
        return accumulated
      }
      if (lastPage.length < perPage) lastPage.push(entry)
      else {
        pages.push([entry])
        const lastEntry = lastPage[perPage - 1]
        pageParams.push(lastEntry.id)
      }
      return accumulated
    },
    { pages: [] as T[][], pageParams: [] as (string | null)[] }
  )

export const infiniteQueryUnshift = <T extends { id: string }>(data: InfiniteData<T[]>, perPage: number, toPrepend: T): InfiniteData<T[]> =>
  reduceEntriesIntoPages([Object.assign({}, toPrepend)].concat(data?.pages.flat(1) || []), perPage)

export const infiniteQueryFilter = <T extends { id: string }>(
  data: InfiniteData<T[]>,
  perPage: number,
  filterTest: (entry: T) => boolean
): InfiniteData<T[]> => {
  const entries = data?.pages.flat(1) || []
  const filteredEntries = entries.filter(filterTest)
  if (entries.length === filteredEntries.length) return data || reduceEntriesIntoPages(entries, perPage)
  return reduceEntriesIntoPages(filteredEntries, perPage)
}

export const infiniteQueryReplace = <T extends { id: string }>(
  data: InfiniteData<T[]>,
  perPage: number,
  replaceTest: (entry: T) => boolean,
  replaceWith: T
): InfiniteData<T[]> => {
  const entries = data?.pages.flat(1) || []
  const entryIndex = entries.findIndex(replaceTest)
  if (entryIndex === -1) return data || reduceEntriesIntoPages(entries, perPage)
  entries.splice(entryIndex, 1, replaceWith)
  return reduceEntriesIntoPages(entries, perPage)
}

export const infiniteQueryMap = <T extends { id: string }>(
  data: InfiniteData<T[]>,
  perPage: number,
  mapper: (value: T, index: number, array: T[]) => unknown & { id: string }
): InfiniteData<(unknown & { id: string })[]> => {
  const entries = data?.pages.flat(1) || []
  const mappedEntries = entries.map(mapper)
  return reduceEntriesIntoPages(mappedEntries, perPage)
}
